import { render, staticRenderFns } from "./permissionList.vue?vue&type=template&id=3682602d&scoped=true"
import script from "./permissionList.vue?vue&type=script&lang=js"
export * from "./permissionList.vue?vue&type=script&lang=js"
import style0 from "./permissionList.vue?vue&type=style&index=0&id=3682602d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3682602d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod-gz-clzjn-management-platform-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3682602d')) {
      api.createRecord('3682602d', component.options)
    } else {
      api.reload('3682602d', component.options)
    }
    module.hot.accept("./permissionList.vue?vue&type=template&id=3682602d&scoped=true", function () {
      api.rerender('3682602d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/module/staff/components/permissionList.vue"
export default component.exports